<template>
  <div class="row mb-2">
    <div class="col">
        <div class="card">
            <a class="card-header" data-toggle="collapse" href="#collapseEvent"
               aria-expanded="true" aria-controls="collapseEvent"
               style="color: white; background-color: steelblue">
              <span style="font-size: 24px"><B> Examples </B></span>
            </a>
            <div id="collapseEvent" class="collapse show">
              <div class="card-text">
                <br/>
                <strong>Here are some examples for QA Data generated through the above two steps. <br/>
                  Please take them as references for your own Data Creation.</strong>
              </div>
              <br/>
              <div id="example-1" style="margin-top: 20px; margin-left: 20px;">
                <span class="card-texts" style="text-align: left; margin-left: 5px; font-size: 20px;"><strong>Example 1</strong></span><br/>
                <table style="margin-top: 5px; float: left;">
                  <tbody>
                    <tr style="background-color: #ffe8de; border-bottom: 2px solid darkgrey;">
                      <td style="width: 100px; text-align: center;">Question</td>
                      <td style="width: 350px; padding-left: 10px;">How to sleep in proper posture, </td>
                    </tr>
                    <tr style="background-color: white">
                      <td style="text-align: center;">Correct</td>
                      <td style="padding-left: 10px;">Sleep straight with a pillow <strong style="color: tomato">under</strong> your head.</td>
                    </tr>
                    <tr style="background-color: white">
                      <td style="text-align: center;">Incorrect</td>
                      <td style="padding-left: 10px;">Sleep straight with a pillow <strong style="color: royalblue">over</strong> your head.</td>
                    </tr>
                  </tbody>
                </table>
                <table style="margin-left: 20px; margin-top: 5px; float: left">
                  <tbody>
                    <tr style="background-color: #e2efff; border-bottom: 2px solid darkgrey;">
                      <td style="width: 120px; text-align: center;">New Question</td>
                      <td style="width: 350px; padding-left: 10px;">How to block the light when sleep</td>
                    </tr>

                    <tr style="background-color: white">
                      <td style="text-align: center;">Correct</td>
                      <td style="padding-left: 10px;">Sleep straight with a pillow <strong style="color: royalblue">over</strong> your head.</td>
                    </tr>

                    <tr style="background-color: white">
                      <td style="text-align: center;">Incorrect</td>
                      <td style="padding-left: 10px;">Sleep straight with a pillow <strong style="color: tomato">under</strong> your head.</td>
                    </tr>
                  </tbody>
                </table>
                <br/><br/><br/><br/><br/><br/>
              </div>
              <div id="example-2" style="margin-top: 20px; margin-left: 20px;">
                <span class="card-texts" style="text-align: left; margin-left: 5px; font-size: 20px;"><strong>Example 2</strong></span><br/>
                <table style="margin-top: 5px; float: left;">
                  <tbody>
                    <tr style="background-color: #ffe8de; border-bottom: 2px solid darkgrey;">
                      <td style="width: 100px; text-align: center;">Question</td>
                      <td style="width: 350px; padding-left: 10px;">What can I do with a milk powder?</td>
                    </tr>
                    <tr style="background-color: white">
                      <td style="text-align: center;">Correct</td>
                      <td style="padding-left: 10px;">you can feed a <strong style="color: tomato">baby</strong>.</td>
                    </tr>
                    <tr style="background-color: white">
                      <td style="text-align: center;">Incorrect</td>
                      <td style="padding-left: 10px;">you can feed a <strong style="color: royalblue"> spider</strong>.</td>
                    </tr>
                  </tbody>
                </table>
                <table style="margin-left: 20px; margin-top: 5px; float: left">
                  <tbody>
                    <tr style="background-color: #e2efff; border-bottom: 2px solid darkgrey;">
                      <td style="width: 120px; text-align: center;">New Question</td>
                      <td style="width: 350px; padding-left: 10px;">What can I do with some bugs?</td>
                    </tr>

                    <tr style="background-color: white">
                      <td style="text-align: center;">Correct</td>
                      <td style="padding-left: 10px;">you can feed a <strong style="color: royalblue">spider</strong>.</td>
                    </tr>

                    <tr style="background-color: white">
                      <td style="text-align: center;">Incorrect</td>
                      <td style="padding-left: 10px;">you can feed a <strong style="color: tomato">a baby</strong>.</td>
                    </tr>
                  </tbody>
                </table>
                <br/><br/><br/><br/><br/><br/>
              </div>
              <div id="example-3" style="margin-top: 20px; margin-left: 20px;">
                <span class="card-texts" style="text-align: left; margin-left: 5px; font-size: 20px;"><strong>Example 3</strong></span><br/>
                <table style="margin-top: 5px; float: left;">
                  <tbody>
                    <tr style="background-color: #ffe8de; border-bottom: 2px solid darkgrey;">
                      <td style="width: 100px; text-align: center;">Question</td>
                      <td style="width: 350px; padding-left: 10px;">To remove grease stains, </td>
                    </tr>
                    <tr style="background-color: white">
                      <td style="text-align: center;">Correct</td>
                      <td style="padding-left: 10px;">simply rub the stain with <strong style="color: tomato">chalk</strong> and toss it into the wash as normal.</td>
                    </tr>
                    <tr style="background-color: white">
                      <td style="text-align: center;">Incorrect</td>
                      <td style="padding-left: 10px;">simply rub the stain with <strong style="color: royalblue">fabric softener</strong> and toss it into the wash as normal.</td>
                    </tr>
                  </tbody>
                </table>
                <table style="margin-left: 20px; margin-top: 5px; float: left">
                  <tbody>
                    <tr style="background-color: #e2efff; border-bottom: 2px solid darkgrey;">
                      <td style="width: 120px; text-align: center;">New Question</td>
                      <td style="width: 350px; padding-left: 10px;">To remove laundry smells</td>
                    </tr>

                    <tr style="background-color: white">
                      <td style="text-align: center;">Correct</td>
                      <td style="padding-left: 10px;">simply rub the stain with <strong style="color: royalblue">fabric softener</strong> and toss it into the wash as normal.</td>
                    </tr>

                    <tr style="background-color: white">
                      <td style="text-align: center;">Incorrect</td>
                      <td style="padding-left: 10px;">simply rub the stain with <strong style="color: tomato">chalk</strong> and toss it into the wash as normal.</td>
                    </tr>
                  </tbody>
                </table>
                <br/><br/><br/><br/><br/><br/>
              </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Creation_examples.vue"
}
</script>

<style scoped>
.card-text {
  margin-left: 20px;
  margin-right: 20px;
}

/*table {*/
/*    font-family: arial, sans-serif;*/
/*    border-collapse: collapse;*/
/*    width: auto;*/
/*    margin-bottom: 20px;*/
/*    background-color: aliceblue;*/
/*}*/
/*td {*/
/*    border: 1px solid #ddd;*/
/*    text-align: left;*/
/*    padding: 8px;*/
/*}*/
</style>